import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=198e5cae"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports